export default [
    {
        title: "Desktop Version",
        subtitle: "1-25 hours",
        text: "Our first step in the development process is to design the desktop version of the store. Based on our designs (or designs provided by a client), we make a desktop version of your store that is both beautiful and functional. Once a design is created, we check everything with our client to ensure they are happy, make edits or add new features, and continue from there. The desktop version sets the tone for the rest, so we put a strong emphasis on it."
    },
    {
        title: "Mobile version",
        subtitle: "1-25 hours",
        text: "Once we have the approval of the desktop version, we move forward with the mobile version. This is because of how connected the mobile and desktop versions are. Once again, we check in with our client, make any necessary edits or add new features, and your mobile store is ready to go!"
    },
    {
        title: "Testing and Finalizing",
        subtitle: "1-25 hours",
        text: "After the mobile and desktop versions have been approved, we make the final checks in all browsers and other popular devices to ensure that everything works perfectly. This process makes sure that we did not miss anything and allows us to catch mistakes before the product is released. Once all of the testing is completed, your store is ready to be finalized and displayed to the public!"
    },
]